<template>
	<CloPlaylist 
		:list="list"
		:title="title"
		:moreUrl="moreUrl"
		:mediaDownloadUrl="mediaDownloadUrl"
	/>
</template>

<script>
import CloPlaylist from '@/media/CloPlaylist/CloPlaylist.vue';

export default ({
	name: 'SpeciesAudioPlaylist',
	components: {
		CloPlaylist,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		moreUrl: {
			type: String,
			required: true,
		},
		mediaDownloadUrl: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			list: [],
			audioAssets: window.audioAssetsJson
		};
	},
	mounted() {
		this.setMediaData()
	},
	methods: {
		setMediaData() {
			if (this.audioAssets && this.audioAssets.galleryAssets) {
				// from gallery
				this.audioAssets.galleryAssets.forEach(item => {
					// remove location name
					item.asset.locName = null
				})
				this.list = this.audioAssets.galleryAssets
			} else if (this.audioAssets && Array.isArray(this.audioAssets) && this.audioAssets.length > 0) {
				// from search results
				let loc = this.audioAssets[0].location;
				let locStr = [
					loc.subnational2Name,
					loc.subnational1Name,
					loc.countryName,
				].filter(x => x).join(', ');
				this.list = [{
					asset: {
						assetId: this.audioAssets[0].assetId,
						mlBaseDownloadUrl: this.mediaDownloadUrl,
						userDisplayName: this.audioAssets[0].userDisplayName,
						title: this.audioAssets[0].taxonomy.comName,
						countryName: locStr,
						obsDtDisplay: this.audioAssets[0].obsDtDisplay,
						citationUrl: window.href_macaulay + this.audioAssets[0].assetId,
						citationName: 'ML ' + this.audioAssets[0].assetId,
					},
				}]
			}
		},
	}
});
</script>

<style lang="scss">
.Playlist-listen {
	display: flex;
	flex-direction: column;
}
</style>
